import Flux from 'lib/flux';
import PricingConstants from 'constants/pricing';

export default Flux.createStore({
  name: 'pricing',

  getInitialState() {
    return {
      tour_id: null,
      addons: {},
      units: {},
      booking_fee: null,
      booking_fee_formatted: null,
      additional_tax: null,
      additional_tax_formatted: null,
      additional_tax_label: null,
      currency: null,
      deposit: null,
      deposit_formatted: null,
      discount: null,
      discount_formatted: null,
      guests: 0,
      remainder: null,
      remainder_formatted: null,
      total: null,
      total_formatted: null,
      guests_price: null,
      guests_price_formatted: null,
      unit_price: null,
      from_unit_price: null,
      unit_price_formatted: null,
      remainder_payment_date: null,
      remainder_in_cash: null,
      remainder_in_credit: null,
      remainder_charge_days_offset: 0,
      loading: false,
      zero_priced: null,
      fully_discounted: false,
      remainder_in_local_currency: null,
      cash_total: null,
      cash_total_formatted: null,
      online_total: null,
      online_total_formatted: null,
      paid_in_cash: null,
      total_in_local_currency: null,
      total_in_local_currency_formatted: null,
      online_discount: null,
      online_discount_formatted: null,
      can_be_paid_in_cash: null,
      tour_name: null,
      privacy_policy_link: null,
      privacy_policy_link_text: null,
      hide_policy_links: false,
      customer_form_fields: {},
      billing_form_fields: {},
    };
  },

  actions: [
    [
      PricingConstants.PREVIEW,
      function () {
        this.state = this.state.set('loading', true);
      },
    ],

    [
      'FORM_DATA_SENT',
      function (formFields) {
        if ('billing_zip_code' in formFields) {
          this.state = this.state.merge({ billing_form_fields: formFields });
        } else {
          this.state = this.state.merge({ customer_form_fields: formFields });
        }
      },
    ],

    [
      PricingConstants.PREVIEW_COMPLETED,
      function (pricing) {
        this.state = this.state.merge(pricing, { loading: false });
      },
    ],
  ],
});
